import { changeLanguage } from "i18next";
import { useState } from "react";
import "../../App.css";
import { camera, fullscreen, menu_panel } from "../../images/index";

const CanvasIcons = () => {
  let enableFullScreen = false;

  const [currentLanguage, setCurrentLanguage] = useState("he");

  function updateScreenLanguage() {
    const lang = currentLanguage === "en" ? "he" : "en";
    setCurrentLanguage(lang);
    changeLanguage(lang);
    return false;
  }

  function toggleFullScreenEnablement() {
    enableFullScreen = !enableFullScreen;

    if (enableFullScreen) {
      return openFullScreen();
    }

    return closeFullScreen();
  }

  /**
   * Method responsible for opening the full screen mode, considering
   * Chrome, Firefox, Safari, Opera, IE and Edge browser's especificity.
   */
  function openFullScreen() {
    if (document.body.requestFullscreen) {
      document.body.requestFullscreen();
    }

    /* Firefox */
    if (document.body.mozRequestFullScreen) {
      document.body.mozRequestFullScreen();
    }

    /* Chrome, Safari and Opera */
    if (document.body.webkitRequestFullscreen) {
      document.body.webkitRequestFullscreen();
    }

    /* IE/Edge */
    if (document.body.msRequestFullscreen) {
      document.body.msRequestFullscreen();
    }
  }

  /**
   * Method responsible for closing the full screen mode, considering
   * Chrome, Firefox, Safari, Opera, IE and Edge browser's especificity.
   */
  function closeFullScreen() {
    if (typeof document.exitFullscreen === "function") {
      return document.exitFullscreen();
    }

    /* Firefox */
    if (typeof document.mozCancelFullScreen === "function") {
      return document.mozCancelFullScreen();
    }

    /* Chrome, Safari and Opera */
    if (typeof document.webkitExitFullscreen === "function") {
      return document.webkitExitFullscreen();
    }

    /* IE/Edge */
    if (typeof document.msExitFullscreen === "function") {
      return document.msExitFullscreen();
    }
  }

  function printScreen() {
    const link = document.createElement("a");
    link.download = "print.png";
    link.href = document.getElementsByTagName("canvas")[0].toDataURL();
    link.click();
  }

  return (
    <>
      <div id="buttons-top" className="canvas-options">
        <button
          className="canvas-options__item"
          onClick={toggleFullScreenEnablement.bind(this)}
        >
          <img
            src={fullscreen}
            alt="Icon representing window expand, showing four arrows pointing to northeast, northwest, southeast and southwest."
          />
        </button>
        <button
          className="canvas-options__item"
          onClick={printScreen.bind(this)}
        >
          <img src={camera} alt="Camera icon representing window capture." />
        </button>
        <button
          className="canvas-options__item"
          onClick={updateScreenLanguage.bind(this)}
        >
          {currentLanguage === "en" ? "עב" : "en"}
        </button>
      </div>
      <div id="btn-menu-panel">
        <img src={menu_panel} alt="Collapse menu" />
      </div>
    </>
  );
};

export default CanvasIcons;
